import styled from "styled-components/macro";

export const StakingWrapper = styled.div`
  background-image: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.5)
  ), url("img/story2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
`;